import { objectKeysToPascalCase, objectKeysToCamelCase } from '../util/convert';
import { omit } from 'lodash';
import _ from 'lodash'

import { getSelected } from 'state/customize/selectors'

function defaultInitialsLocation(putterModel) {
  var defaultStyle = (putterModel.personalizationStyle.length) ? putterModel.personalizationStyle[0].id : 0;
  return {
    enabled: false,
    characters: '',
    personalizationStyleId: defaultStyle,
    separateWithPeriods: false,
  };
}

function getInitialsFromPutter(putterModel){
  const locs = putterModel.initialsLocation.map(loc => {
    return { [loc.label] : defaultInitialsLocation(putterModel) } 
  });
  return Object.assign({}, ...locs);
}

function getInitialsFromInstanceInitials(initials){
  return { 
      characters: !!initials.characters ? initials.characters : '',
      enabled:  !!initials.characters ? true : false,
      personalizationStyleId: !!initials.personalizationStyleId ? initials.personalizationStyleId : 9,
      personalizationStyleLabel: !!initials.personalizationStyleLabel ? initials.personalizationStyleLabel : 'Straight',
      separateWithPeriods : initials.separateWithPeriods,
    }
  };

function getSightDotFromPutter(putterModel){
  const sightDotDefault = _.find(putterModel.sightDot, (sightDot) => sightDot.numberOfLines === 0);
  return sightDotDefault ? sightDotDefault.id : 0;
}

function getFlangeLineFromPutter(putterModel){
  const flangeLineDefault = _.find(putterModel.flangeLine, (flangeLine) => flangeLine.numberOfLines === 0);
  return flangeLineDefault ? flangeLineDefault.id : 0;
}

function getReshaftFromPutter(putterModel){
  const reshaftDefault = _.find(putterModel.reshaft, (reshaft) => reshaft.keepShaft);
  return reshaftDefault ? reshaftDefault.id : 0;
}

export function fromPutter(putterModel){
  return { 
    model: putterModel.id, 
    label: putterModel.label,
    isExactMatch: false,
    insuranceValue: 0, 
    authorizeSurcharge: true, 
    restorationType: 0, 
    finish: 0, 
    initials: getInitialsFromPutter(putterModel), 
    stampSelections: [], 
    topLine: 0, 
    flangeLine: getFlangeLineFromPutter(putterModel), //'Keep As Is'
    sightDot: getSightDotFromPutter(putterModel), //'Keep As Is'
    paintFill: 7, //0,
    paintFillLocations: [], 
    topWeight: 0,
    weight: 0,
    weightEngraving: 0,
    weightEngravingHeel: 0,
    weightEngravingToe: 0,
    topWeightEngraving: 0,
    weightEngravingTopToe: 0,
    weightEngravingTopHeel: 0,
    loft: 0,//18, 
    lie: 0,//8, 
    length: 0,//7,
    desiredLength: 0, 
    reshaft: getReshaftFromPutter(putterModel),//2, 
    grip: 0,
    gripWrap: 0, 
    shaftBand: 0, 
    headCover: 0, 
    buyAPutter: 0,
    accessories: [], 
    authentication: 0,
  }
}

/* 18759: Invalid options rollback
export function isInstanceOptionsValid(putterModel, savedInstance){
  
  let isValid = true;
  isValid = (savedInstance.restorationType ? putterModel.restorationType.filter(r => r.id === savedInstance.restorationType).length > 0 : true)
    && (savedInstance.finish ? putterModel.finish.filter(f => f.id === savedInstance.finish).length > 0 : true)
    && (savedInstance.stampSelections.length > 0 ? savedInstance.stampSelections.filter(ss => putterModel.stamp.filter(s => s.id === ss.stampId).length > 0).length === savedInstance.stampSelections.length : true)
    && (savedInstance.topLine && putterModel.topLine.length > 0 ? putterModel.topLine.filter(t => t.id === savedInstance.topLine).length > 0 : true)
    && (putterModel.flangeLine.length > 0 ? putterModel.flangeLine.filter(f => f.id === savedInstance.flangeLine).length > 0 : true)
    && (savedInstance.sightDot && putterModel.sightDot.length > 0 ? putterModel.sightDot.filter(f => f.id === savedInstance.sightDot).length > 0 : true)
    && putterModel.paintFill.filter(p => p.id === savedInstance.paintFill).length > 0
    && (savedInstance.paintFillLocations.length > 0 ? savedInstance.paintFillLocations.filter(l => putterModel.paintFillColor.filter(p => p.id === l.colorId).length > 0).length === savedInstance.paintFillLocations.length : true)
    && (savedInstance.topWeight && putterModel.topWeight.length > 0 ? putterModel.topWeight.filter(t => t.id === savedInstance.topWeight).length > 0 : true)
    && (savedInstance.weight && putterModel.weight.length > 0 ? putterModel.weight.filter(w => w.id === savedInstance.weight).length > 0 : true)
    && (savedInstance.weightEngraving && putterModel.weightEngraving.length > 0 ? putterModel.weightEngraving.filter(w => w.id === savedInstance.weightEngraving).length > 0 : true)
    && (savedInstance.weightEngravingHeel && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingHeel).length > 0 : true)
    && (savedInstance.weightEngravingToe && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingToe).length > 0 : true)
    && (savedInstance.topWeightEngraving && putterModel.topWeightEngraving.length > 0 ? putterModel.topWeightEngraving.filter(w => w.id === savedInstance.topWeightEngraving).length > 0 : true)
    && (savedInstance.weightEngravingTopToe && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopToe).length > 0 : true)
    && (savedInstance.weightEngravingTopHeel && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopHeel).length > 0 : true)
    && (savedInstance.loft ? putterModel.loft.filter(l => l.id === savedInstance.loft).length > 0 : true)
    && (savedInstance.lie ? putterModel.lie.filter(l => l.id === savedInstance.lie).length > 0 : true)
    && (savedInstance.length ? putterModel.length.filter(l => l.id === savedInstance.length).length > 0 : true)
    && (savedInstance.desiredLength && putterModel.desiredLength.length > 0 ? putterModel.desiredLength.filter(d => d.id === savedInstance.desiredLength).length > 0 : true)
    && (savedInstance.reshaft ? putterModel.reshaft.filter(r => r.id === savedInstance.reshaft).length > 0 : true)
    && (savedInstance.grip ? putterModel.grip.filter(g => g.id === savedInstance.grip).length > 0 : true)
    && (savedInstance.gripWrap ? putterModel.gripWrap.filter(g => g.id === savedInstance.gripWrap).length > 0 : true)
    && (savedInstance.shaftBand ? putterModel.shaftBand.filter(s => s.id === savedInstance.shaftBand).length > 0 : true)
    && (savedInstance.headCover ? putterModel.headCover.filter(h => h.id === savedInstance.headCover).length > 0 : true)
    && (savedInstance.authentication ? putterModel.authentication.filter(a => a.id === savedInstance.authentication).length > 0 : true)
    ;

  console.log('instance options valid:');
  console.log( (savedInstance.restorationType ? putterModel.restorationType.filter(r => r.id === savedInstance.restorationType).length > 0 : true) ); 
  console.log( (savedInstance.finish ? putterModel.finish.filter(f => f.id === savedInstance.finish).length > 0 : true) ); 
  console.log( (savedInstance.stampSelections.length > 0 ? savedInstance.stampSelections.filter(ss => putterModel.stamp.filter(s => s.id === ss.stampId).length > 0).length === savedInstance.stampSelections.length : true)); 
  console.log( (savedInstance.topLine && putterModel.topLine.length > 0 ? putterModel.topLine.filter(t => t.id === savedInstance.topLine).length > 0 : true) ); 
  console.log( (putterModel.flangeLine.length > 0 ? putterModel.flangeLine.filter(f => f.id === savedInstance.flangeLine).length > 0 : true) ); 
  console.log( (savedInstance.sightDot && putterModel.sightDot.length > 0 ? putterModel.sightDot.filter(f => f.id === savedInstance.sightDot).length > 0 : true) ); 
  console.log( putterModel.paintFill.filter(p => p.id === savedInstance.paintFill).length > 0); 
  console.log( (savedInstance.paintFillLocations.length > 0 ? savedInstance.paintFillLocations.filter(l => putterModel.paintFillColor.filter(p => p.id === l.colorId).length > 0).length === savedInstance.paintFillLocations.length : true)); 
  console.log( (savedInstance.topWeight && putterModel.topWeight.length > 0 ? putterModel.topWeight.filter(t => t.id === savedInstance.topWeight).length > 0 : true) ); 
  console.log( (savedInstance.weight && putterModel.weight.length > 0 ? putterModel.weight.filter(w => w.id === savedInstance.weight).length > 0 : true) ); 
  console.log( (savedInstance.weightEngraving && putterModel.weightEngraving.length > 0 ? putterModel.weightEngraving.filter(w => w.id === savedInstance.weightEngraving).length > 0 : true) ); 
  console.log( (savedInstance.weightEngravingHeel && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingHeel).length > 0 : true) ); 
  console.log( (savedInstance.weightEngravingToe && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingToe).length > 0 : true) ); 
  console.log( (savedInstance.topWeightEngraving && putterModel.topWeightEngraving.length > 0 ? putterModel.topWeightEngraving.filter(w => w.id === savedInstance.topWeightEngraving).length > 0 : true) ); 
  console.log( (savedInstance.weightEngravingTopToe && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopToe).length > 0 : true) ); 
  console.log( (savedInstance.weightEngravingTopHeel && putterModel.weightEngravingStamp.length > 0 ? putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopHeel).length > 0 : true) ); 
  console.log( (savedInstance.loft ? putterModel.loft.filter(l => l.id === savedInstance.loft).length > 0 : true) ); 
  console.log( (savedInstance.lie ? putterModel.lie.filter(l => l.id === savedInstance.lie).length > 0 : true) ); 
  console.log( (savedInstance.length ? putterModel.length.filter(l => l.id === savedInstance.length).length > 0 : true) ); 
  console.log( (savedInstance.desiredLength && putterModel.desiredLength.length > 0 ? putterModel.desiredLength.filter(d => d.id === savedInstance.desiredLength).length > 0 : true)); 
  console.log( (savedInstance.reshaft ? putterModel.reshaft.filter(r => r.id === savedInstance.reshaft).length > 0 : true) ); 
  console.log( (savedInstance.grip ? putterModel.grip.filter(g => g.id === savedInstance.grip).length > 0 : true) );
  console.log( (savedInstance.gripWrap ? putterModel.gripWrap.filter(g => g.id === savedInstance.gripWrap).length > 0 : true) );
  console.log( (savedInstance.shaftBand ? putterModel.shaftBand.filter(s => s.id === savedInstance.shaftBand).length > 0 : true) );
  console.log( (savedInstance.headCover ? putterModel.headCover.filter(h => h.id === savedInstance.headCover).length > 0 : true) );
  console.log( (savedInstance.authentication ? putterModel.authentication.filter(a => a.id === savedInstance.authentication).length > 0 : true) );

  return isValid;
}
*/
export function removeInvalidOptions(putterModel, savedInstance){
  
  //check if a weight engraving is selected
  if(savedInstance.weight > 0)
  {
    if(savedInstance.weightEngravingHeel > 0)
    {
      let stamp = _.find(putterModel.weightEngravingStamp, { id : savedInstance.weightEngravingHeel });
      //check if the selected weight engraving is disabled for this weight id
      if(stamp && stamp.disabledWeightIds.split(',').indexOf(savedInstance.weight.toString()) > -1 )
      {
        //remove the weight engraving selection
        savedInstance = Object.assign({}, 
          savedInstance,
          {
            weightEngravingHeel: 0,
          }
        );
      }
    }
    //check if a weight engraving is selected
    if(savedInstance.weightEngravingToe > 0)
    {
      let stamp = _.find(putterModel.weightEngravingStamp, { id : savedInstance.weightEngravingToe });
      //check if the selected weight engraving is disabled for this weight id
      if(stamp && stamp.disabledWeightIds.split(',').indexOf(savedInstance.weight.toString()) > -1 )
      {
        //remove the weight engraving selection
        savedInstance = Object.assign({}, 
          savedInstance,
          {
            weightEngravingToe: 0,
          }
        );
      }
    }
  }
  //check if a weight engraving is selected
  //check if a weight engraving is selected
  if(savedInstance.topWeight > 0)
  {
    if(savedInstance.weightEngravingTopHeel > 0)
    {
      let stamp = _.find(putterModel.weightEngravingStamp, { id : savedInstance.weightEngravingTopHeel });
      //check if the selected weight engraving is disabled for this weight id
      if(stamp && stamp.disabledWeightIds.split(',').indexOf(savedInstance.topWeight.toString()) > -1 )
      {
        //remove the weight engraving selection
        savedInstance = Object.assign({}, 
          savedInstance,
          {
            weightEngravingTopHeel: 0,
          }
        );
      }
    }
    //check if a weight engraving is selected
    if(savedInstance.weightEngravingTopToe > 0)
    {
      let stamp = _.find(putterModel.weightEngravingStamp, { id : savedInstance.weightEngravingTopToe });
      //check if the selected weight engraving is disabled for this weight id
      if(stamp && stamp.disabledWeightIds.split(',').indexOf(savedInstance.topWeight.toString()) > -1 )
      {
        //remove the weight engraving selection
        savedInstance = Object.assign({}, 
          savedInstance,
          {
            weightEngravingTopToe: 0,
          }
        );
      }
    }
  }

  return Object.assign({}, 
    savedInstance,
    {
      //customInstanceId: savedInstance.customInstanceId,
      //orderLineItemId: savedInstance.orderLineItemId,
      //model: savedInstance.model, 
      //label: savedInstance.label,
      //isExactMatch: savedInstance.isExactMatch,
      //insuranceValue: savedInstance.insuranceValue, 
      //authorizeSurcharge: savedInstance.authorizeSurcharge, 
      restorationType: putterModel.restorationType.filter(r => r.id === savedInstance.restorationType).length > 0 ? savedInstance.restorationType : 0, 
      finish: putterModel.finish.filter(f => f.id === savedInstance.finish).length > 0 ? savedInstance.finish : 0,
      //initials: savedInstance.initials,
      stampSelections: savedInstance.stampSelections.filter(ss => putterModel.stamp.filter(s => s.id === ss.stampId).length > 0),
      topLine: putterModel.topLine.filter(t => t.id === savedInstance.topLine).length > 0 ? savedInstance.topLine : 0, 
      flangeLine: putterModel.flangeLine.filter(f => f.id === savedInstance.flangeLine).length > 0 ? savedInstance.flangeLine : getFlangeLineFromPutter(putterModel),
      sightDot: putterModel.sightDot.filter(f => f.id === savedInstance.sightDot).length > 0 ? savedInstance.sightDot : savedInstance.topLine === 0 ? getSightDotFromPutter(putterModel) : 0,
      paintFill: (!!savedInstance.paintFill ? (putterModel.paintFill.filter(p => p.id === savedInstance.paintFill).length > 0 ? savedInstance.paintFill : 7) : 7),
      paintFillLocations: savedInstance.paintFillLocations.filter(l => putterModel.paintFillColor.filter(p => p.id === l.colorId).length > 0), 
      topWeight: putterModel.topWeight.filter(t => t.id === savedInstance.topWeight).length > 0 ? savedInstance.topWeight : 0,
      weight: putterModel.weight.filter(w => w.id === savedInstance.weight).length > 0 ? savedInstance.weight : 0,
      weightEngraving: putterModel.weightEngraving.filter(w => w.id === savedInstance.weightEngraving).length > 0 ? savedInstance.weightEngraving : 0,
      weightEngravingHeel: putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingHeel).length > 0 ? savedInstance.weightEngravingHeel : 0,
      weightEngravingToe: putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingToe).length > 0 ? savedInstance.weightEngravingToe : 0,
      topWeightEngraving: putterModel.topWeightEngraving.filter(w => w.id === savedInstance.topWeightEngraving).length > 0 ? savedInstance.topWeightEngraving : 0,
      weightEngravingTopToe: putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopToe).length > 0 ? savedInstance.weightEngravingTopToe : 0,
      weightEngravingTopHeel: putterModel.weightEngravingStamp.filter(w => w.id === savedInstance.weightEngravingTopHeel).length > 0 ? savedInstance.weightEngravingTopHeel : 0,
      loft: putterModel.loft.filter(l => l.id === savedInstance.loft).length > 0 ? savedInstance.loft : 0,
      lie: putterModel.lie.filter(l => l.id === savedInstance.lie).length > 0 ? savedInstance.lie : 0,
      length: putterModel.length.filter(l => l.id === savedInstance.length).length > 0 ? savedInstance.length : 0,
      desiredLength: putterModel.desiredLength ? (putterModel.desiredLength.filter(d => d.id === savedInstance.desiredLength).length > 0 ? savedInstance.desiredLength : 0) : 0, 
      reshaft: putterModel.reshaft.filter(r => r.id === savedInstance.reshaft).length > 0 ? savedInstance.reshaft : getReshaftFromPutter(putterModel),
      grip: putterModel.grip.filter(g => g.id === savedInstance.grip).length > 0 ? savedInstance.grip : 0,
      gripWrap: putterModel.gripWrap.filter(g => g.id === savedInstance.gripWrap).length > 0 ? savedInstance.gripWrap : 0, 
      shaftBand: putterModel.shaftBand.filter(s => s.id === savedInstance.shaftBand).length > 0 ? savedInstance.shaftBand : 0, 
      headCover: putterModel.headCover.filter(h => h.id === savedInstance.headCover).length > 0 ? savedInstance.headCover : 0, 
      buyAPutter: putterModel.buyAPutter.filter(b => b.id === savedInstance.buyAPutter).length > 0 ? savedInstance.buyAPutter : 0, 
      //accessories: (!!savedInstance.accessories ? savedInstance.accessories : []), 
      authentication: putterModel.authentication.filter(a => a.id === savedInstance.authentication).length > 0 ? savedInstance.authentication : 0, 
      //userCanUpdate: savedInstance.userCanUpdate || false,
      //userCanUpdateOrder: savedInstance.userCanUpdateOrder || false,
      //notes: savedInstance.notes, 
    }
  );
}

export function fromAPIInstance(data){
  let savedInstance = _.chain(data)
    .value();
    
  savedInstance = objectKeysToCamelCase(savedInstance);
  return { 
    customInstanceId: savedInstance.customInstanceId,
    orderLineItemId: savedInstance.orderLineItemId,
    model: savedInstance.model.id, 
    label: savedInstance.model.label,
    isExactMatch: true,
    insuranceValue: savedInstance.insuranceValue, 
    authorizeSurcharge: savedInstance.authorizeSurcharge, 
    restorationType: savedInstance.restoration.id, 
    finish: savedInstance.finish.id,
    initials: {
      InitialsBumperHeel : getInitialsFromInstanceInitials(savedInstance.initials.initialsBumperHeel),
      InitialsBumperToe : getInitialsFromInstanceInitials(savedInstance.initials.initialsBumperToe),
      InitialsFace : getInitialsFromInstanceInitials(savedInstance.initials.initialsFace),
    },
    stampSelections: savedInstance.stampSelections.map(loc => ({ ...loc, enabled: true })),
    topLine: savedInstance.topLine.id, 
    flangeLine: savedInstance.flangeLine.id,
    sightDot: savedInstance.sightDot.id,
    paintFill: (!!savedInstance.paintFillSelections.paintFill.id ? savedInstance.paintFillSelections.paintFill.id : 7),
    paintFillLocations: savedInstance.paintFillSelections.locations, 
    topWeight: savedInstance.weightSelections.topWeight.id,
    weight: savedInstance.weightSelections.weight.id,
    weightEngraving: savedInstance.weightSelections.weightEngraving.id,
    weightEngravingHeel: savedInstance.weightSelections.weightEngravingHeel.id,
    weightEngravingToe: savedInstance.weightSelections.weightEngravingToe.id,
    topWeightEngraving: savedInstance.weightSelections.topWeightEngraving.id,
    weightEngravingTopToe: savedInstance.weightSelections.weightEngravingTopToe.id,
    weightEngravingTopHeel: savedInstance.weightSelections.weightEngravingTopHeel.id,
    loft: savedInstance.loft.id,
    lie: savedInstance.lie.id,
    length: savedInstance.length.id,
    desiredLength: savedInstance.length.desiredValueId, 
    reshaft: savedInstance.reshaft.id,
    grip: savedInstance.grip.id,
    gripWrap: savedInstance.gripWrap.id, 
    shaftBand: savedInstance.shaftBand.id, 
    headCover: savedInstance.headcover.id, 
    buyAPutter: savedInstance.buyAPutter.id,
    accessories: (!!savedInstance.accessories ? savedInstance.accessories : []), 
    authentication: savedInstance.authentication.id, //For 17711, we no longer want to set to do not authenticate if auth id is 0
    //? savedInstance.authentication.id : 99999, //no auth so set to do not authenticate (id: 99999)
    userCanUpdate: savedInstance.userCanUpdate || false,
    userCanUpdateOrder: savedInstance.userCanUpdateOrder || false,
    notes: savedInstance.notes, 
  }
}

export function fromDefaultInstance(currentInstance, defaultInstance)
{
    //only set default if none selected
    let instance = currentInstance;
    instance.finish = currentInstance.finish || defaultInstance.finish;
    instance.loft = currentInstance.loft || defaultInstance.loft;
    instance.length = currentInstance.length || defaultInstance.length;
    instance.desiredLength = currentInstance.desiredLength || defaultInstance.desiredLength;
    instance.lie = currentInstance.lie || defaultInstance.lie;
    instance.weight = currentInstance.weight || defaultInstance.weight;
    return instance;
}

function id(i) { return (i) ? { Id: i } : {} }; 

function lengthId(length, state) {
  var o = id(length)
  var desiredLength = getSelected(state, 'desiredLength');
  if (desiredLength){ 
    o.DesiredValue = desiredLength.label;
  }
  return o;
}

export function formatForAPI(customizeState, action){ 
  var instanceModel = customizeState.instance;
  var putterModel = customizeState.putter;
  var instanceIntent = customizeState.instanceIntent;

  var idToSend = 0;
  if ((action === "save" && instanceIntent === "updateSaved" && instanceModel.userCanUpdate) ||
    (action === "cart" && instanceIntent === "updateOrder" && instanceModel.userCanUpdateOrder)){
    idToSend = instanceModel.customInstanceId 
  }

  var orderIdtoSend= 0;
  if (action === "cart" && instanceIntent === "updateOrder" && instanceModel.userCanUpdateOrder){
    orderIdtoSend = instanceModel.orderLineItemId
  }

  return {
    CustomInstanceId: idToSend,
    OrderLineItemId : orderIdtoSend,
    Model: id(instanceModel.model),
    FormType: "interactive",
    Label: instanceModel.label,
    IsExactMatch: instanceModel.isExactMatch.toString(),
    InsuranceValue: instanceModel.insuranceValue, 
    AuthorizeSurcharge: instanceModel.authorizeSurcharge.toString(),
    Restoration: id(instanceModel.restorationType), 
    Finish: id(instanceModel.finish), 
    Initials: {
      InitialsFace: omit(objectKeysToPascalCase(instanceModel.initials.InitialsFace || defaultInitialsLocation(putterModel)), 'Enabled'),
      InitialsBumperHeel: omit(objectKeysToPascalCase(instanceModel.initials.InitialsBumperHeel || defaultInitialsLocation(putterModel)), 'Enabled'),
      InitialsBumperToe: omit(objectKeysToPascalCase(instanceModel.initials.InitialsBumperToe || defaultInitialsLocation(putterModel)), 'Enabled'),
    },
    StampSelections: objectKeysToPascalCase(instanceModel.stampSelections).map(s => omit(s, 'Enabled')),
    TopLine: id(instanceModel.topLine), 
    FlangeLine: id(instanceModel.flangeLine), 
    SightDot: id(instanceModel.sightDot), 
    PaintFillSelections: {
      PaintFill : id(instanceModel.paintFill),
      Locations : objectKeysToPascalCase(instanceModel.paintFillLocations), 
    },
    WeightSelections: {
      topWeight: id(instanceModel.topWeight),
      weight: id(instanceModel.weight),
      weightEngraving: id(instanceModel.weightEngraving),
      weightEngravingHeel: id(instanceModel.weightEngravingHeel),
      weightEngravingToe: id(instanceModel.weightEngravingToe),
      topWeightEngraving: id(instanceModel.topWeightEngraving),
      weightEngravingTopToe: id(instanceModel.weightEngravingTopToe),
      weightEngravingTopHeel: id(instanceModel.weightEngravingTopHeel), 
    }, 
    Loft: id(instanceModel.loft), 
    Lie: id(instanceModel.lie), 
    Length: lengthId(instanceModel.length, customizeState),
    Reshaft: id(instanceModel.reshaft), 
    Grip: id(instanceModel.grip), 
    GripWrap: id(instanceModel.gripWrap), 
    ShaftBand: id(instanceModel.shaftBand), 
    HeadCover: id(instanceModel.headCover), 
    BuyAPutter: id(instanceModel.buyAPutter),
    Accessories: instanceModel.accessories.map(id),
    Authentication: (instanceModel.authentication === 99999) ? id(0) : id(instanceModel.authentication),
    Notes: instanceModel.notes,
  }; 
} 